import { z } from "zod";

export const getTransportOrderParamSchema = z.object({
	transportOrderId: z.uuid(),
});

export type GetTransportOrderParamSchema = z.infer<typeof getTransportOrderParamSchema>;
